import { apolloLineHeightBody } from "@nexthink/apollo-tokens";
import styled from "styled-components";
import { variant } from "styled-system";
import Icon from "../icons/Icon";
import { StyledButton } from "../button/Button.style";
export const ROUND_BUTTON_ICON_SIZE = 20;
export const BARE_BUTTON_ICON_SIZE = 16;
export const StyledButtonIcon = styled(StyledButton).withConfig({ displayName: "StyledButtonIcon_APC-7281-productShell", componentId: "sc-f2pi5n" })(({ theme }) => ({
    "&&": {
        boxSizing: "border-box",
        height: "auto",
        lineHeight: apolloLineHeightBody,
        verticalAlign: "middle",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        display: "inline-flex",
        padding: "0",
        backgroundColor: "transparent",
        border: "1px solid transparent",
        color: theme.colors.apolloColorTextPrimary,
        "&[data-focused], &[data-focus-visible-added]": {
            border: `1px solid ${theme.colors.apolloColorStrokeFocus}`,
        },
        cursor: "pointer",
        "&:disabled": {
            cursor: "auto",
            color: theme.colors.apolloColorTextDisabled,
        },
        "& span": {
            display: "inherit",
        },
    },
}), ({ theme }) => variant({
    prop: "$variant",
    variants: {
        bare: {
            "&&": {
                borderRadius: 0,
                width: `${BARE_BUTTON_ICON_SIZE}px`,
                height: `${BARE_BUTTON_ICON_SIZE}px`,
            },
        },
        round: {
            "&&": {
                borderRadius: "50%",
                width: `${ROUND_BUTTON_ICON_SIZE}px`,
                height: `${ROUND_BUTTON_ICON_SIZE}px`,
                transition: "background .25s",
                "&:hover:not([disabled])": {
                    background: theme.colors.apolloColorBackgroundIconButtonHover,
                },
            },
        },
    },
}));
export const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon_APC-7281-productShell", componentId: "sc-9tnvva" })({
    "&&": {
        color: "inherit",
        width: "auto",
        height: "16px",
    },
});
//# sourceMappingURL=ButtonIcon.style.js.map